import type { TranslationTree } from '../../types';

export const referenceAliases: TranslationTree = {
  referenceAliases: {
    tabs: {
      title: 'Alias de référence',
    },
    displayMode: {
      title: 'Mode d\'affichage',
      reference: 'Référence',
      alias: 'Alias',
      save: 'Enregistrer',
    },
    table: {
      reference: 'Référence',
      alias: 'Alias',
      actions: 'Actions',
      empty: 'Aucun alias défini pour le moment.',
      loading: 'Chargement...',
    },
    form: {
      add: 'Ajouter un alias',
      edit: 'Modifier l\'alias',
      delete: 'Supprimer l\'alias',
      referencePlaceholder: 'Sélectionner une référence',
      aliasPlaceholder: 'ex. Insert-Alu-6mm',
      save: 'Enregistrer',
      cancel: 'Annuler',
    },
    errors: {
      duplicateAlias: 'Cet alias est déjà utilisé pour une autre référence.',
      emptyFields: 'La référence et l\'alias sont obligatoires.',
      noCompany: 'Veuillez d\'abord sélectionner une entreprise.',
      default: 'Une erreur est survenue.',
    },
    companyPicker: {
      label: 'Entreprise',
      placeholder: 'Sélectionner une entreprise…',
      prompt: 'Sélectionnez une entreprise pour gérer ses alias de référence.',
    },
    helperText: 'Alias connu pour cette référence : {{alias}}',
  },
};
